import { render, staticRenderFns } from "./SpeciesAdd.vue?vue&type=template&id=4f3fa5f2"
import script from "./SpeciesAdd.vue?vue&type=script&lang=js"
export * from "./SpeciesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports